import { ActionTypes } from "./actions.js";
import { getInitialState } from "./state.js";
const initialState = getInitialState();
const reducer = (state = initialState, action) => {
    switch (action.type) {
        case ActionTypes.setMessage:
            return {
                ...state,
                message: action.payload.message,
                type: action.payload.type || "polite"
            };
        case ActionTypes.reset:
            return {
                ...state,
                message: "",
                type: "polite"
            };
        default:
            return state;
    }
};
export { reducer, getInitialState };
